import { css } from 'styled-components';

export const Outline = css`
  outline: 2px solid;
  outline-color: transparent;
  outline-offset: -2px;
`;

export const OutlineError = css`
  ${Outline};
  border-color: var(--field-border-error);
`;
